package pl.decks.personal.pages.ievp

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import pl.decks.personal.components.graphics.ExuraLogo
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.styles.SiteLayout
import kotlin.math.pow

enum class IEVPSection(
    val title: String,
    val flavourQuote: String? = null,
    val background: (@Composable (transition: Float) -> Unit)? = null,
    val invertColors: (ColorMode) -> Boolean = { false },
) {
    WHY(
        "IEVP, what's that?",
        "it is not me, who knows the company best",
        {
            Box(IEVPStylesheet.Background.Why.toModifier().opacity(it.pow(4f)))
        }
    ),
    PITCH(
        "Elevator Pitch",
        "get to know me in 30 seconds",
        {
            Box(IEVPStylesheet.Background.Pitch.toModifier().opacity(it.pow(0.25f)))
        },
    ),
    KEY_INSIGHTS("Key Insights", "just a quick peek!"),
    LAST_YEARS(
        "Last 2.5 years",
        "things I learned made it feel like ten",
        {
            val accent = ColorMode.current.toSitePalette().accents.secondary.toRgb()
            Box(
                modifier = IEVPStylesheet.Background.LastYears.toModifier(),
                contentAlignment = Alignment.Center,
            ) {
                ExuraLogo(
                    modifier = Modifier
                        .height(SiteLayout.Fraction.Half)
                        .translateY((-10).percent)
                        .maxWidth(75.percent)
                        .color(
                            if(ColorMode.current.isLight) accent.lightened(0.75f)
                            else accent.darkened(0.75f)
                        )
                )
            }
        },
    ),
    PROFILE("Profile", "they say circle is the perfect shape, hence I'm well-rounded"),
    SKILLS("Skills", "don't even get me started with interests!"),
    BACKGROUND(
        "Background",
        "is it a Mathe-writer or a Wri-tician? I could never decide",
        {
            Box(
                modifier = IEVPStylesheet.Background.Background.toModifier().opacity(it.pow(4f)),
                contentAlignment = Alignment.Center,
            ) {
                Row {
                    SpanText("π")
                    FaPen()
                }
            }
        },
    ),
    EXPERIENCE(
        "Experience",
        "be like water. Or something",
        { },
    ),
    ;

    fun toId(): String = "evp-section-${name.lowercase()}"
}
